<template>
  <footer>
    <div class="foot-h"></div>
    <div id="left-foot" v-on:tap="goHome()">
      <i class="rds-icon rds-icon-home"></i>
      <!-- <img src="../assets/rds-life-fonticons/home.svg" alt="radio" class="rds-icon-home" /> -->
    </div>
    <div class="grow">
      <RdsPlayer class="rds-player"></RdsPlayer>
    </div>

    <div id="right-foot" v-on:tap="toggleMediaPage">
      <!-- <i class="rds-icon rds-icon-radio_icon"></i> -->
      <img src="../assets/rds-life-fonticons/radio_icon.svg" alt="radio" class="rds-icon-radio" />
    </div>
  </footer>
</template>

<script>
import RdsPlayer from '@/components/RdsPlayer.vue';
// @ is an alias to /src
export default {
  name: 'rds-footer',
  components: {
    RdsPlayer
  },
  methods: {
    toggleMediaPage() {
      console.log('toggleMediaPage');

      if (this.$route.name === 'rdsMedia') {
        this.goBack();
      } else {
        this.$router.push('/rdsMedia');
      }
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
    },
    goHome() {
      if (this.$route.name !== 'home') {
        this.$router.push('/');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
footer {
  z-index: 30;
  display: flex;
  padding: 0 21px 21px;
  background-color: $footer-background-color;
  position: relative;
  min-height: 45px;
  max-height: 45px;
  filter: drop-shadow(0px 6px 10px rgba(0, 0, 0, 0.3));
  background-size: contain;
  & > * {
    margin-top: auto;
    // margin-bottom: 10px;
  }
  .foot-h {
    width: 286px;
    background-image: url(../assets/images/footer_background2.svg);
    background-position: center -10.5px;
    background-size: auto;
    background-repeat: no-repeat;
    background-origin: content-box;
    height: 83px;
    position: absolute;
    top: -83px;
    left: 50%;
    transform: translate(-50%);
    z-index: 1;
    pointer-events: none;
  }
  .rds-player {
    flex-grow: 1;
    left: 50%;
    position: absolute;
    top: 30%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }
  i {
    font-size: 1.55em;
    &.rds-icon-radio {
      font-size: 1.47em;
    }
  }
  #right-foot {
    display: flex;
  }
  .rds-icon-radio {
    width: 31px;
  }
  i,
  img,
  svg {
    padding: 20px;
    margin: -20px;
    // border-radius: 50%;
  }
}
</style>
